import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CreditCardPaymentInfoModel } from 'src/app/core/models/members/user/credit-card-payment-info-model';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';

@Component({
  selector: 'app-creditcard',
  templateUrl: './creditcard.component.html',
  styleUrls: ['./creditcard.component.scss']
})
export class CreditcardComponent implements OnInit {

  
  cardEnding: string = "xxxx xxxx xxxx"
  updateExistingCard: boolean = false;

  @Input() userCreditcard: CreditCardPaymentInfoModel = new CreditCardPaymentInfoModel; 
  @Output() userCreditcardChange = new EventEmitter<CreditCardPaymentInfoModel>();

  @Input() disableInputs: boolean = false; 
  @Input() submitted: boolean = false; 
  @Input() includeValidation: boolean = false;
  @Input() validationValue: boolean = false;
  @Input() showUpdate: boolean = true;
  @Input() newCard: boolean = false;
  
  constructor(
    private toasterNotificationService: ToasterNotificationService,
    private myfileApiService: MyfileApiService
  ) {}
  
  ngOnInit(){
    if(this.userCreditcard.expiryMonth && this.userCreditcard.expiryYear){
      if(this.userCreditcard.expiryMonth < 10){
        this.userCreditcard.expiryDate = `0${this.userCreditcard.expiryMonth}/${this.userCreditcard.expiryYear - 2000}`
      }else{
        this.userCreditcard.expiryDate = `${this.userCreditcard.expiryMonth}/${this.userCreditcard.expiryYear - 2000}`
      }
    }

    if(this.userCreditcard.creditCardNumber.length == 15||16){
      if(!this.userCreditcard.creditCardNumber.includes(" ")){
        this.userCreditcard.creditCardNumber = `${this.userCreditcard.creditCardNumber.slice(0,4)} ${this.userCreditcard.creditCardNumber.slice(4,8)} ${this.userCreditcard.creditCardNumber.slice(8,12)} ${this.userCreditcard.creditCardNumber.slice(12,this.userCreditcard.creditCardNumber.length)}`;
      }
    }
    if(this.userCreditcard.creditCardNumber.length == 15){
      this.cardEnding = `${this.cardEnding} ${this.userCreditcard.creditCardNumber.slice(15,18)}`
    }else{
      this.cardEnding = `${this.cardEnding} ${this.userCreditcard.creditCardNumber.slice(15,19)}`
    }
  }
  
  updateCard(){
    this.updateExistingCard = true;
  }

  saveCard(){
    this.submitted = true; 
    if(this.validation()){
      this.myfileApiService.isCreditCardValid(this.userCreditcard).subscribe((ccValidationResult: any) => {
        if (ccValidationResult) {
          this.updateExistingCard = false;
          this.newCard = false;
          if(this.userCreditcard.creditCardNumber.length == 15||16){
            if(!this.userCreditcard.creditCardNumber.includes(" ")){
              this.userCreditcard.creditCardNumber = `${this.userCreditcard.creditCardNumber.slice(0,4)} ${this.userCreditcard.creditCardNumber.slice(4,8)} ${this.userCreditcard.creditCardNumber.slice(8,12)} ${this.userCreditcard.creditCardNumber.slice(12,this.userCreditcard.creditCardNumber.length)}`;
            }
          }
          if(this.userCreditcard.creditCardNumber.length == 15){
            this.cardEnding = `$xxxx xxxx xxxx ${this.userCreditcard.creditCardNumber.slice(15,18)}`
          }else{
            this.cardEnding = `$xxxx xxxx xxxx ${this.userCreditcard.creditCardNumber.slice(15,19)}`
          }
        }
        this.submitted = false;
      });
    }
  }

  validation(): boolean{   

    if(    this.userCreditcard.creditCardNumber && this.userCreditcard.creditCardNumber.length == 15||16
        && this.userCreditcard.cardHolderName && this.userCreditcard.cardHolderName != ""
        && this.userCreditcard.cvvNumber && this.userCreditcard.cvvNumber.length > 2
        && this.userCreditcard.expiryDate && this.userCreditcard.expiryDate.length == 5
      ){
        this.userCreditcard.expiryMonth = Number(this.userCreditcard.expiryDate.split('/')[0]); 
        this.userCreditcard.expiryYear = (Number(this.userCreditcard.expiryDate.split('/')[1])+ 2000); 
        return true; 
      }
    this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
    return false
  }

}
